import styled from 'styled-components';
import { Common, color } from '@stockbit/ui';

const {
  Autocomplete: BaseAutocomplete,
  Flex,
  Text,
  IconWrapper,
  Input,
} = Common;

const Relative = styled.div`
  position: relative;
  background: ${color.light};
`;

const CatalogItem = styled(Text).attrs({ size: '13px', p: '3px 5px' })`
  border-radius: 8px;
  border: 1px solid ${color.primary};
  color: ${color.primary};
  width: fit-content;
  :hover {
    background: ${color.primary};
    color: ${color.light};
  }
`;

const SearchBarWrapper = styled(Flex)`
  display: ${({ isVisible = true }) => (isVisible ? 'flex' : 'none')};
  background: ${color.light};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 15px 16px;
  z-index: 2;
`;

const IconClose = styled(IconWrapper)`
  border: 1px solid ${color.lowgray};
  background: ${color.light};
  border-left: none;
  border-radius: 2px;
`;

const Autocomplete = styled(BaseAutocomplete)`
  z-index: 99999 !important;
  .rc-virtual-list-holder-inner > :first-child {
    display: none !important;
  }

  .ant-select-dropdown {
    width: 60% !important;
    top: -55px;
  }
`;

const CustomInput = styled(Input)`
  &:focus {
    border-right-width: 0px !important;
  }
  &:hover {
    border-right-width: 0px !important;
  }
`;

const IconmoonWrapper = styled.div`
  position: fixed;
  top: 60px;
  right: 60px;
  cursor: pointer;
`;

export {
  Autocomplete,
  CatalogItem,
  Relative,
  SearchBarWrapper,
  IconClose,
  CustomInput,
  IconmoonWrapper,
};
